import { render, staticRenderFns } from "./SummaryReport.vue?vue&type=template&id=db8c2b42&scoped=true"
import script from "./SummaryReport.vue?vue&type=script&lang=js"
export * from "./SummaryReport.vue?vue&type=script&lang=js"
import style0 from "./SummaryReport.vue?vue&type=style&index=0&id=db8c2b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8c2b42",
  null
  
)

export default component.exports